
import React, { useEffect, useState } from "react";

import { MdSmartphone } from "react-icons/md";

import {
  FaGlobe,
  FaFacebookF,
  FaInstagram,
} from "react-icons/fa";

import { useTranslation } from "react-i18next";

import "./BuildProjectPage.css";

// =========================================================
// EDGE FUNCTION
// =========================================================

const EDGE_FUNCTION_URL =
  "https://xrxkmksbutmuouddtzcm.supabase.co/functions/v1/create-project-order";



const BuildProjectPage = () => {
  const { t, i18n } = useTranslation();

 

  const [step, setStep] = useState(0);



  const [projectType, setProjectType] = useState("");


  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");



  const [showLangMenu, setShowLangMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");



  useEffect(() => {
    const handlePageShow = () => {
      setLoading(false);
    };

    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  // =========================================================
  // LANGUAGE
  // =========================================================

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);

    document.dir = lang === "ar" ? "rtl" : "ltr";

    setShowLangMenu(false);
  };



  const LangSwitcher = () => (
    <div className="about-topbar">

      <div className="lang-switcher">

        <button
          type="button"
          className="lang-toggle"
          onClick={() =>
            setShowLangMenu((prev) => !prev)
          }
          aria-label={t("Toggle language menu")}
        >
          <FaGlobe size={18} />

          <span>
            {i18n.language.toUpperCase()}
          </span>
        </button>

        {showLangMenu && (
          <div className="language-dropdown">

            <div
              onClick={() =>
                changeLanguage("en")
              }
            >
              {t("English")}
            </div>

            <div
              onClick={() =>
                changeLanguage("ar")
              }
            >
              {t("Arabic")}
            </div>

          </div>
        )}

      </div>

    </div>
  );

  // =========================================================
  // SOCIAL
  // =========================================================

  const SocialRow = () => (
    <div
      className="bottom-social-row reveal"
      style={{ "--delay": "0.3s" }}
    >

      <a
        href="https://www.facebook.com/EmkaCode.tech"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
      >
        <FaFacebookF />
      </a>

      <a
        href="https://www.instagram.com/emkacode/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
      >
        <FaInstagram />
      </a>

    </div>
  );

  // =========================================================
  // SELECT PROJECT TYPE
  // =========================================================

  const selectProjectType = (type) => {

    setProjectType(type);

    setErrorMessage("");

    setLoading(false);

    setStep(1);
  };

  // =========================================================
  // START BUILDING
  // =========================================================

  const startBuilding = async () => {

    // -------------------------------------------------------
    // Clear previous error
    // -------------------------------------------------------

    setErrorMessage("");

    // -------------------------------------------------------
    // Validate name
    // -------------------------------------------------------

    if (!name.trim()) {

      setErrorMessage(
        t("Please enter your name.")
      );

      return;
    }

    // -------------------------------------------------------
    // Validate email
    // -------------------------------------------------------

    if (!email.trim()) {

      setErrorMessage(
        t("Please enter your email.")
      );

      return;
    }

    // -------------------------------------------------------
    // Validate email format
    // -------------------------------------------------------

    const emailRegex =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email.trim())) {

      setErrorMessage(
        t("Please enter a valid email address.")
      );

      return;
    }

    // -------------------------------------------------------
    // Validate phone
    // -------------------------------------------------------

    if (!phone.trim()) {

      setErrorMessage(
        t("Please enter your phone number.")
      );

      return;
    }

    // -------------------------------------------------------
    // Validate project type
    // -------------------------------------------------------

    if (
      projectType !== "Mobile App" &&
      projectType !== "Website"
    ) {

      setErrorMessage(
        t("Please select a project type.")
      );

      return;
    }

    // -------------------------------------------------------
    // Prevent double click
    // -------------------------------------------------------

    if (loading) {
      return;
    }

    setLoading(true);

    try {

      // =====================================================
      // SEND REQUEST TO EDGE FUNCTION
      // =====================================================

      const response = await fetch(
        EDGE_FUNCTION_URL,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify({

            projectType: projectType,

            name: name.trim(),

            email: email.trim(),

            phone: phone.trim(),

          }),
        }
      );

      // =====================================================
      // READ RESPONSE
      // =====================================================

      const data = await response.json();

      console.log(
        "Create project order response:",
        data
      );

      // =====================================================
      // EDGE FUNCTION ERROR
      // =====================================================

      if (!response.ok || !data.success) {

        throw new Error(
          data.message ||
          t(
            "Something went wrong. Please try again."
          )
        );
      }

      // =====================================================
      // CHECK TALLY URL
      // =====================================================

      if (!data.tally_url) {

        throw new Error(
          t("Tally form link was not returned.")
        );
      }

      // =====================================================
      // LOG SUCCESS
      // =====================================================

      console.log(
        "Order created successfully:",
        data.order_no
      );

      console.log(
        "Order ID:",
        data.order_id
      );

      console.log(
        "Tally URL:",
        data.tally_url
      );


      window.location.href =
        data.tally_url;

    } catch (error) {

      console.error(
        "Create project order error:",
        error
      );

      setErrorMessage(
        error.message ||
        t(
          "Something went wrong. Please try again."
        )
      );


      setLoading(false);
    }
  };

  // =========================================================
  // PREVIOUS
  // =========================================================

  const goPrevious = () => {

    if (loading) {
      return;
    }

    setStep(0);

    setProjectType("");

    setErrorMessage("");

  };

  // =========================================================
  // STEP 0
  // SELECT PROJECT TYPE
  // =========================================================

  if (step === 0) {

    return (

      <div className="buildpage-select-container">

        <div className="ambient-glow"></div>

        <LangSwitcher />

        <div
          className="buildpage-form reveal"
          style={{
            "--delay": "0.1s",
          }}
        >

          <h2>
            {t("What do you want to build?")}
          </h2>

          <div className="buildpage-options">

            {/* =================================================
                MOBILE APP
            ================================================= */}

            <div
              className="buildpage-option"
              onClick={() =>
                selectProjectType("Mobile App")
              }
            >

              <MdSmartphone size={40} />

              <span>
                {t("Mobile App")}
              </span>

            </div>

            {/* =================================================
                WEBSITE
            ================================================= */}

            <div
              className="buildpage-option"
              onClick={() =>
                selectProjectType("Website")
              }
            >

              <FaGlobe size={38} />

              <span>
                {t("Website")}
              </span>

            </div>

          </div>

        </div>

        <SocialRow />

      </div>

    );
  }

  // =========================================================
  // STEP 1
  // USER INFORMATION
  // =========================================================

  return (

    <div className="buildpage-form-container">

      <div className="ambient-glow"></div>

      <LangSwitcher />

      <div
        className="buildpage-form reveal"
        style={{
          "--delay": "0.1s",
        }}
      >

        {/* =====================================================
            ICON
        ===================================================== */}

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "15px",
          }}
        >

          {projectType === "Mobile App" ? (

            <MdSmartphone size={55} />

          ) : (

            <FaGlobe size={50} />

          )}

        </div>

        {/* =====================================================
            TITLE
        ===================================================== */}

        <h2>
          {t("Let's turn your idea into reality")}
        </h2>

        {/* =====================================================
            SUBTITLE
        ===================================================== */}

        <p className="subtitle">

          {t(
            "Complete your information so we can start working on your idea."
          )}

        </p>

        {/* =====================================================
            PROJECT TYPE
        ===================================================== */}

        <p className="subtitle">

          {projectType === "Mobile App"
            ? t("Mobile App")
            : t("Website")}

        </p>

        {/* =====================================================
            NAME
        ===================================================== */}

        <label htmlFor="project-name">

          {t("Name")}

        </label>

        <input
          id="project-name"
          type="text"
          value={name}
          onChange={(e) =>
            setName(e.target.value)
          }
          placeholder={t("Enter your name")}
          autoComplete="name"
          disabled={loading}
        />

        {/* =====================================================
            EMAIL
        ===================================================== */}

        <label htmlFor="project-email">

          {t("Email")}

        </label>

        <input
          id="project-email"
          type="email"
          value={email}
          onChange={(e) =>
            setEmail(e.target.value)
          }
          placeholder={t("Enter your email")}
          autoComplete="email"
          disabled={loading}
        />

        {/* =====================================================
            PHONE
        ===================================================== */}

        <label htmlFor="project-phone">

          {t("Phone Number")}

        </label>

        <input
          id="project-phone"
          type="tel"
          value={phone}
          onChange={(e) =>
            setPhone(e.target.value)
          }
          placeholder={t("Enter your phone number")}
          autoComplete="tel"
          disabled={loading}
        />

        {/* =====================================================
            ERROR
        ===================================================== */}

        {errorMessage && (

          <p
            className="form-error"
            role="alert"
          >
            {errorMessage}
          </p>

        )}

        {/* =====================================================
            BUTTONS
        ===================================================== */}

        <div className="button-group">

          <button
            type="button"
            onClick={goPrevious}
            className="prev-btn"
            disabled={loading}
          >
            {t("Previous")}
          </button>

          <button
            type="button"
            className="submit-btn"
            onClick={startBuilding}
            disabled={loading}
          >

            {loading
              ? t("Creating your order...")
              : t("Start Building")}

          </button>

        </div>

      </div>

      <SocialRow />

    </div>

  );
};

export default BuildProjectPage;

